var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"pb-10 mb-40 border-b-2 border-grey-100"},[_c('Back',{staticClass:"inline-block py-10",attrs:{"route":{ name: 'learn' },"title":"learn.back_to_learn"}})],1),_vm._l((_vm.brainExercises),function(brainExercise){return _c('BrainExercise',{key:brainExercise.exerciseCd,attrs:{"brainExercise":brainExercise}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }